/* ================================================================
   MPS — QUIZ TRANSLATIONS
   One object per locale. Add a new key (e.g. 'de', 'it') to extend.
   FR is the authoritative base — all other locales must mirror its structure.
   Loaded before quiz-scoring.js; quiz engine reads window.__quizI18n.
================================================================ */

window.__quizI18n = {

  /* ==============================================================
     FRANÇAIS (base)
  ============================================================== */
  fr: {

    /* ── UI STRINGS (buttons, labels, shared text) ────────────── */
    ui: {
      btn_continue:        'Continuer',
      btn_start:           'Commencer le test',
      btn_see_results:     'Voir mes résultats',
      btn_skip_step:       'Passer cette étape',
      btn_restart:         'Refaire le test',
      btn_view_cart:       'Voir mon panier \u2192',
      btn_continue_shop:   'Continuer mes achats',
      btn_add_to_cart:     'Ajouter au panier',
      btn_add_bundle:      'Ajouter le bundle au panier',
      btn_adding:          'Ajout en cours\u2026',
      btn_added:           'Ajouté \u2713',
      btn_bundle_added:    'Bundle ajouté \u2713',
      btn_error_retry:     'Erreur, veuillez réessayer',
      email_placeholder:   'votre@email.com',
      marketing_optin:     'J\u2019accepte de recevoir par e-mail les conseils et offres de MyPureSkin. Désinscription possible à tout moment.',

      scale_low:           'Pas du tout',
      scale_high:          'Tout à fait',

      yes:                 'Oui',
      no:                  'Non',

      upload_cta:          'Ajouter une photo de votre visage',
      upload_hint:         'JPG, PNG \u00b7 max 10 Mo',
      upload_preview_alt:  'Aperçu',
      photo_prompt:        'Souhaitez-vous ajouter une photo de votre visage pour affiner votre score\u00a0?',

      plan_one_time:       'Achat unique',

      result_hello:        'Bonjour',
      result_no_name:      'Voici vos résultats,',
      result_subtitle:     'Voici votre',
      result_label:        'STRUCTURAL AGING SCORE\u2122',
      result_objective:    'Objectif\u00a0:',
      result_actions:      'Que faire',
      reco_badge_label:    'Recommandation personnalisée',
      reco_badge_sub:      'Basée sur votre Structural Aging Score\u2122 et votre profil unique.',
      bundle_label:        'Offre combinée',
      bundle_desc_suffix:  '\u2014 ajoutez les deux produits en un clic.',
    },

    /* ── INTRO SLIDE ──────────────────────────────────────────── */
    intro: {
      eyebrow:    'Swiss Excellence',
      title:      'Votre Structural<br>Aging Score\u2122',
      sub:        'Comprendre comment votre structure biologique évolue avec le temps, et comment la soutenir.',
      disclaimer: 'Cet outil n\u2019est pas un diagnostic médical. Il vise à contextualiser votre vieillissement et à promouvoir une approche de healthy aging.',
    },

    /* ── CONSENT SLIDE ───────────────────────────────────────── */
    consent: {
      title_prefix: 'Bienvenue',
      intro:        'Nous allons vous poser quelques questions afin de vous proposer une sélection de compléments MyPureSkin, personnalisée selon vos besoins et vos objectifs.',
      disclaimer:   'Cet outil n\u2019est pas un diagnostic médical. Il vise à contextualiser votre vieillissement et à promouvoir une approche de healthy aging, globale et proactive.',
      checkbox:     'En cochant cette case, j\u2019accepte que les données personnelles que je fournis à MyPureSkin soient utilisées afin de créer ma recommandation personnalisée de compléments.',
    },

    /* ── LOADING SLIDE ───────────────────────────────────────── */
    loading: {
      title: 'Calcul de votre score<br>en cours\u2026',
      steps: [
        'Analyse du profil biologique',
        'Évaluation des facteurs de mode de vie',
        'Calcul des marqueurs cutanés',
        'Croisement avec les données cliniques',
        'Personnalisation des recommandations',
        'Score finalisé \u2713',
      ],
    },

    /* ── QUIZ NODES ───────────────────────────────────────────
       Only translatable strings per node.id.
       The quiz engine patches NODES after load.
    ─────────────────────────────────────────────────────────── */
    nodes: {
      prenom: {
        question:    'Comment vous<br>appelez-vous\u00a0?',
        placeholder: 'Votre prénom',
      },
      trans_profil: {
        eyebrow:   'Étape 1 \u2014 Profil',
        title:     'Commençons par<br>votre profil.',
        subtitle:  'Ces informations nous permettent de calculer votre score de vieillissement biologique de référence.',
      },
      age: {
        question: 'Quel est votre âge\u00a0?',
        unit:     'ans',
      },
      genre: {
        question: 'Quel est votre sexe\u00a0?',
        options: [
          { label: 'Femme' },
          { label: 'Homme' },
        ],
      },
      taille: {
        question: 'Quelle est votre taille\u00a0?',
      },
      poids: {
        question: 'Quel est votre poids\u00a0?',
      },
      trans_vie: {
        eyebrow:  'Étape 2 \u2014 Mode de vie',
        title:    'Parlons de votre<br>mode de vie.',
        subtitle: 'Ces facteurs influencent directement le rythme du vieillissement biologique.',
      },
      tabac: {
        question: 'Fumez-vous actuellement\u00a0?',
        options: [
          { label: 'Non' },
          { label: 'Occasionnellement' },
          { label: 'Régulièrement' },
        ],
      },
      alcool: {
        question: 'Quelle est votre consommation d\u2019alcool\u00a0?',
        options: [
          { label: 'Rare ou jamais' },
          { label: '1\u20133 fois par semaine' },
          { label: 'Plus fréquemment' },
        ],
      },
      stress: {
        question: 'Comment évaluez-vous votre niveau de stress au quotidien\u00a0?',
        options: [
          { label: 'Faible',   sub: 'Je me sens serein(e) au quotidien' },
          { label: 'Modéré',   sub: 'Des pics de stress ponctuels' },
          { label: 'Élevé',    sub: 'Stress chronique ou fréquent' },
        ],
        whyAsk: {
          title: 'Pourquoi nous demandons cela',
          text:  'Le stress chronique accélère le vieillissement cellulaire via l\u2019élévation du cortisol, impactant directement la qualité de la peau et des tissus biologiques.',
        },
      },
      trans_meno: {
        eyebrow:  'Transitions hormonales',
        title:    'Parlons de votre<br>équilibre hormonal.',
        subtitle: 'Ces informations nous permettent de personnaliser davantage vos recommandations.',
      },
      meno_concernee: {
        question: 'Êtes-vous concernée par la ménopause\u00a0?',
        options: [
          { label: 'Oui' },
          { label: 'Non' },
          { label: 'Je ne sais pas' },
        ],
      },
      meno_stade: {
        question: 'À quel stade vous situez-vous aujourd\u2019hui\u00a0?',
        options: [
          { label: 'Péri-ménopause',  sub: 'Cycles irréguliers, premiers changements hormonaux' },
          { label: 'Pré-ménopause',   sub: 'Symptômes hormonaux, mais règles encore présentes' },
          { label: 'Ménopause',       sub: 'Arrêt des règles depuis plus de 12 mois' },
          { label: 'Post-ménopause',  sub: 'Équilibre hormonal stabilisé après la ménopause' },
        ],
      },
      trans_objectifs: {
        eyebrow:  'Étape 3 \u2014 Objectifs',
        title:    'Quels sont vos objectifs d\u2019amélioration\u00a0?',
        subtitle: 'Nous personnaliserons nos recommandations en fonction de vos priorités.',
      },
      objectifs: {
        question: 'Quels sont vos objectifs prioritaires\u00a0?',
        sub:      'Sélection multiple possible',
        options: [
          { label: 'Énergie & vitalité' },
          { label: 'Peau du visage' },
          { label: 'Peau du corps' },
          { label: 'Cheveux & ongles' },
          { label: 'Gestion du stress' },
          { label: 'Équilibre hormonal' },
          { label: 'Récupération sportive' },
          { label: 'Réduction de l\u2019inflammation' },
          { label: 'Perte de poids & cellulite' },
          { label: 'Réduction du vieillissement biologique' },
        ],
      },
      trans_peau: {
        eyebrow:  'Étape 4 \u2014 Peau du visage',
        title:    'Analysons votre peau du visage.',
        subtitle: 'Sur une échelle de 1 à 5, évaluez honnêtement les changements observés sur votre peau.',
      },
      peau_densite: {
        question: 'Ma peau a perdu en densité et en fermeté avec le temps.',
      },
      peau_marques: {
        question: 'Ma peau marque plus facilement qu\u2019avant (rides, plis, signes de fatigue).',
      },
      peau_qualite: {
        question: 'La qualité globale de ma peau s\u2019est dégradée ces dernières années.',
      },
      photo: {
        question: 'Analyse visuelle',
        sub:      'Optionnelle mais recommandée',
        whyAsk: {
          title: 'Pourquoi nous demandons cela',
          text:  'Cette image est analysée à l\u2019aide d\u2019une intelligence artificielle comparée à nos données cliniques, afin de mieux contextualiser votre score cutané. Aucune donnée n\u2019est utilisée à des fins de diagnostic.',
        },
      },
      trans_energie: {
        eyebrow:  'Étape 5 \u2014 Énergie & Récupération',
        title:    'Évaluons votre énergie<br>et votre récupération.',
        subtitle: 'Ces indicateurs fonctionnels reflètent la capacité de régénération de votre organisme.',
      },
      energie_group_a: {
        groupTitle: 'Énergie & régénération',
        items: [
          { question: 'Je récupère moins vite qu\u2019il y a quelques années.' },
          { question: 'Les périodes de fatigue durent plus longtemps.' },
          { question: 'J\u2019ai l\u2019impression que mon corps se régénère plus lentement.' },
        ],
      },
      energie_group_b: {
        groupTitle: 'Résilience & inflammaging perçu',
        items: [
          { question: 'Je ressens une fatigue de fond persistante.' },
          { question: 'Mon corps est plus sensible au stress qu\u2019avant.' },
          { question: 'J\u2019ai une sensation régulière de rigidité ou de lourdeur corporelle.' },
        ],
      },
      sport: {
        question: 'Quand je fais du sport\u00a0:',
        sub:      'Choix multiples',
        options: [
          { label: 'Je récupère rapidement' },
          { label: 'J\u2019ai souvent des douleurs articulaires' },
          { label: 'J\u2019ai souvent des douleurs musculaires' },
          { label: 'Je ressens une fatigue prolongée après l\u2019effort' },
        ],
      },
      trans_cellulite: {
        eyebrow:  'Étape 6 \u2014 Composition corporelle',
        title:    'Alimentation et<br>composition corporelle.',
        subtitle: 'Ces éléments complètent votre profil fonctionnel et métabolique.',
      },
      alimentation: {
        question: 'Mon alimentation est globalement équilibrée.',
      },
      fruits_legumes: {
        question: 'Ma consommation de fruits et légumes est en moyenne\u00a0:',
        options: [
          { label: 'Rare ou inexistante' },
          { label: '1\u20132 portions par jour' },
          { label: 'Tous les jours (3+ portions)' },
        ],
      },
      cellulite_hanches: {
        question: 'Présence de cellulite au niveau des hanches\u00a0?',
      },
      cellulite_jambes: {
        question: 'Cellulite visible au niveau des jambes\u00a0?',
      },
      email: {
        question: 'Dernière étape avant vos résultats\u00a0!',
        sub:      'Renseignez votre email pour recevoir vos recommandations personnalisées.',
      },
    },

    /* ── RESULT PAGE CONTENT ──────────────────────────────────
       homme: keyed by product combination
       femme: keyed by combinaison number (c1–c8)
    ─────────────────────────────────────────────────────────── */
    results: {
      homme: {
        // Repair + Contour  (older || high IMC)
        repair_contour: {
          statusTitle:    'Structure fragilisée',
          objective:      'Soutien renforcé de la régénération et de la structure',
          interpretation: 'Votre structure biologique présente des signes de fragilisation avancée. À ce stade, l\u2019approche doit être globale et fonctionnelle\u00a0: aller au-delà de l\u2019apparence pour soutenir les mécanismes de réparation, la récupération, la qualité des tissus et l\u2019équilibre métabolique, avec un impact direct sur la silhouette, la mobilité et la qualité de vie.',
          quote:          'À ce stade, l\u2019enjeu dépasse l\u2019apparence\u00a0: il faut aussi soutenir la fonctionnalité, la récupération, la qualité des tissus et l\u2019équilibre métabolique.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice de MyPureSkin',
          actions: [
            'Soutenir intensivement les mécanismes biologiques de réparation',
            'Améliorer la capacité de récupération et la résilience globale',
            'Réduire l\u2019inflammation chronique et le stress oxydatif',
            'Préserver l\u2019équilibre inflammatoire',
            'Soutenir la qualité des tissus, lutter contre la cellulite et activer le drainage',
            'Favoriser un remodelage plus harmonieux de la silhouette',
          ],
        },
        // Repair only  (older, normal IMC)
        repair: {
          statusTitle:    'Structure à soutenir',
          objective:      'Soutien renforcé de la régénération',
          interpretation: 'Votre structure biologique commence à montrer des signes de fragilisation progressive. À ce stade, l\u2019approche doit être globale\u00a0: aller au-delà de l\u2019apparence pour soutenir la fonction, la capacité de récupération et la qualité des tissus, avec un impact direct sur la qualité de vie.',
          quote:          'À ce stade, l\u2019enjeu dépasse l\u2019apparence\u00a0: il s\u2019agit aussi de soutenir la fonctionnalité, la récupération et la qualité des tissus.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice de MyPureSkin',
          actions: [
            'Soutenir intensivement les mécanismes biologiques de réparation',
            'Améliorer la capacité de récupération et la résilience globale',
            'Réduire l\u2019inflammation chronique et le stress oxydatif',
          ],
        },
        // Lift + Contour  (younger, high IMC)
        contour: {
          statusTitle:    'Structure à soutenir',
          objective:      'Stabilisation & réparation',
          interpretation: 'Les mécanismes biologiques de réparation commencent à ralentir. La priorité est de stabiliser la structure existante et de soutenir activement les processus naturels de réparation.',
          quote:          'L\u2019organisme perd progressivement sa capacité de réparation. Les mécanismes biologiques doivent être soutenus.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice de MyPureSkin',
          actions: [
            'Ralentir l\u2019accélération du vieillissement structurel',
            'Soutenir la régénération tissulaire',
            'Restaurer la qualité de la peau et la résilience globale',
            'Préserver l\u2019équilibre inflammatoire',
            'Lutter contre la cellulite et activer le drainage',
          ],
        },
        // Lift only  (younger, normal IMC)
        lift: {
          statusTitle:    'Structure bien préservée à soutenir',
          objective:      'Prévention & maintien',
          interpretation: 'Votre structure biologique est globalement bien conservée. À ce stade, l\u2019enjeu n\u2019est pas de corriger, mais de ralentir les mécanismes de dégradation biologique liés au vieillissement, avant qu\u2019ils ne s\u2019installent.',
          quote:          'À ce stade, on ne corrige pas encore. On préserve la structure.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice de MyPureSkin',
          actions: [
            'Soutenir la densité cutanée',
            'Maintenir les mécanismes naturels de régénération',
            'Préserver l\u2019équilibre inflammatoire',
          ],
        },
      },

      femme: {
        // C1 : < 35 ans, IMC < 25  → Glow + Lift
        c1: {
          statusTitle:    'Structure bien préservée à soutenir',
          objective:      'Prévention & maintien',
          interpretation: 'Votre structure biologique est globalement bien conservée. À ce stade, l\u2019enjeu n\u2019est pas de corriger, mais de ralentir les mécanismes de dégradation biologique liés au vieillissement, avant qu\u2019ils ne s\u2019installent.',
          quote:          'À ce stade, on ne corrige pas encore. On préserve la structure.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice de MyPureSkin',
          actions: [
            'Soutenir la densité cutanée',
            'Maintenir les mécanismes naturels de régénération',
            'Préserver l\u2019équilibre inflammatoire',
          ],
        },
        // C2 : < 35 ans, IMC ≥ 25  → Glow + Lift + Contour
        c2: {
          statusTitle:    'Structure bien préservée à soutenir',
          objective:      'Prévention, maintien & accompagnement de la perte de poids',
          interpretation: 'Votre structure biologique est globalement bien conservée. À ce stade, il ne s\u2019agit pas de corriger une dégradation structurelle, mais de préserver les fondations tout en accompagnant une réduction du tissu adipeux. L\u2019enjeu est de soutenir les fonctions métaboliques, la qualité des tissus et la tonicité, afin de favoriser une perte de poids plus harmonieuse et durable.',
          quote:          'À ce stade, on ne corrige pas encore. On préserve la structure — tout en soutenant l\u2019équilibre métabolique.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice de MyPureSkin',
          actions: [
            'Préserver la densité et la qualité des tissus',
            'Maintenir les mécanismes naturels de régénération',
            'Soutenir l\u2019équilibre inflammatoire et métabolique',
            'Accompagner la perte de poids sans fragiliser la structure',
            'Favoriser le drainage et l\u2019harmonie de la silhouette',
          ],
        },
        // C3 : 35-44 ans, IMC < 26  → Lift
        c3: {
          statusTitle:    'Structure bien préservée à soutenir',
          objective:      'Prévention & maintien',
          interpretation: 'Votre structure biologique est globalement bien conservée. À ce stade, l\u2019enjeu n\u2019est pas de corriger, mais de ralentir les mécanismes de dégradation biologique liés au vieillissement, avant qu\u2019ils ne s\u2019installent.',
          quote:          'À ce stade, on ne corrige pas encore. On préserve la structure.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice de MyPureSkin',
          actions: [
            'Soutenir la densité cutanée',
            'Maintenir les mécanismes naturels de régénération',
            'Préserver l\u2019équilibre inflammatoire',
          ],
        },
        // C4 : 35-44 ans, IMC ≥ 26  → Lift + Contour
        c4: {
          statusTitle:    'Structure bien préservée à soutenir',
          objective:      'Prévention, maintien & accompagnement de la perte de poids',
          interpretation: 'Votre structure biologique est globalement bien conservée. À ce stade, il ne s\u2019agit pas de corriger une dégradation structurelle, mais de préserver les fondations tout en accompagnant une réduction du tissu adipeux. L\u2019enjeu est de soutenir les fonctions métaboliques, la qualité des tissus et la tonicité, afin de favoriser une perte de poids plus harmonieuse et durable.',
          quote:          'À ce stade, on ne corrige pas encore. On préserve la structure — tout en soutenant l\u2019équilibre métabolique.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice de MyPureSkin',
          actions: [
            'Préserver la densité et la qualité des tissus',
            'Maintenir les mécanismes naturels de régénération',
            'Soutenir l\u2019équilibre inflammatoire et métabolique',
            'Accompagner la perte de poids sans fragiliser la structure',
            'Favoriser le drainage et l\u2019harmonie de la silhouette',
          ],
        },
        // C5 : 45-54 ans, IMC < 27  → Lift
        c5: {
          statusTitle:    'Structure bien préservée à soutenir',
          objective:      'Prévention, maintien & anticipation des changements hormonaux',
          interpretation: 'Votre structure biologique est globalement bien conservée. À ce stade, l\u2019enjeu n\u2019est pas de corriger, mais de ralentir les mécanismes de dégradation biologique liés au vieillissement, tout en anticipant les changements hormonaux associés à la péri-ménopause ou à la ménopause. Cette phase clé influence la qualité des tissus, l\u2019inflammation et la capacité de régénération, d\u2019où l\u2019importance d\u2019un soutien préventif.',
          quote:          'À ce stade, on ne corrige pas encore. On préserve la structure.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice de MyPureSkin',
          actions: [
            'Soutenir la densité et la qualité des tissus',
            'Maintenir les mécanismes naturels de régénération',
            'Préserver l\u2019équilibre inflammatoire',
            'Anticiper les impacts hormonaux sur la structure cutanée et tissulaire',
            'Soutenir les impacts hormonaux de la ménopause',
          ],
        },
        // C6 : 45-54 ans, IMC ≥ 27  → Lift + Contour
        c6: {
          statusTitle:    'Structure bien préservée à soutenir',
          objective:      'Prévention, maintien & anticipation des changements hormonaux',
          interpretation: 'Votre structure biologique est globalement bien conservée. À ce stade, l\u2019enjeu n\u2019est pas de corriger, mais de ralentir les mécanismes de dégradation biologique liés au vieillissement, tout en anticipant les changements hormonaux associés à la péri-ménopause ou à la ménopause. Cette phase clé peut s\u2019accompagner de modifications du métabolisme, d\u2019une tendance à la prise de poids et de changements dans la répartition des graisses, tout en influençant la qualité des tissus, l\u2019inflammation et la capacité de régénération. Un soutien préventif permet de préserver la structure, l\u2019harmonie de la silhouette et le confort corporel.',
          quote:          'À ce stade, on ne corrige pas encore. On préserve la structure.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice de MyPureSkin',
          actions: [
            'Soutenir la densité et la qualité des tissus',
            'Maintenir les mécanismes naturels de régénération',
            'Préserver l\u2019équilibre inflammatoire',
            'Anticiper les impacts hormonaux sur la structure cutanée et tissulaire',
            'Accompagner l\u2019équilibre métabolique pour limiter la prise de poids hormonale',
            'Favoriser le drainage et limiter l\u2019installation de la cellulite',
          ],
        },
        // C7 : 55+ ans, IMC < 28  → Repair
        c7: {
          statusTitle:    'Structure à soutenir',
          objective:      'Soutien renforcé de la régénération',
          interpretation: 'Votre structure biologique commence à montrer des signes de fragilisation progressive. À ce stade, l\u2019approche doit être globale\u00a0: aller au-delà de l\u2019apparence pour soutenir la fonction, la capacité de récupération et la qualité des tissus avec un impact direct sur la qualité de vie.',
          quote:          'À ce stade, l\u2019enjeu dépasse l\u2019apparence\u00a0: il s\u2019agit aussi de soutenir la fonctionnalité, la récupération et la qualité des tissus.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice de MyPureSkin',
          actions: [
            'Soutenir intensivement les mécanismes biologiques de réparation',
            'Améliorer la capacité de récupération et la résilience globale',
            'Réduire l\u2019inflammation chronique et le stress oxydatif',
          ],
        },
        // C8 : 55+ ans, IMC ≥ 28  → Repair + Contour
        c8: {
          statusTitle:    'Structure fragilisée',
          objective:      'Soutien renforcé de la régénération et de la structure',
          interpretation: 'Votre structure biologique présente des signes de fragilisation avancée. À ce stade, l\u2019approche doit être globale et fonctionnelle\u00a0: aller au-delà de l\u2019apparence pour soutenir les mécanismes de réparation, la récupération, la qualité des tissus et l\u2019équilibre métabolique avec un impact direct sur la silhouette, la mobilité et la qualité de vie.',
          quote:          'À ce stade, l\u2019enjeu dépasse l\u2019apparence\u00a0: il faut aussi soutenir la fonctionnalité, la récupération, la qualité des tissus et l\u2019équilibre métabolique.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice de MyPureSkin',
          actions: [
            'Soutenir intensivement les mécanismes biologiques de réparation',
            'Améliorer la capacité de récupération et la résilience globale',
            'Réduire l\u2019inflammation chronique et le stress oxydatif',
            'Préserver l\u2019équilibre inflammatoire',
            'Soutenir la qualité des tissus, lutter contre la cellulite et activer le drainage',
            'Favoriser un remodelage plus harmonieux de la silhouette',
          ],
        },
      },
    },
  },


  /* ==============================================================
     ENGLISH
  ============================================================== */
  en: {

    ui: {
      btn_continue:        'Continue',
      btn_start:           'Start the test',
      btn_see_results:     'See my results',
      btn_skip_step:       'Skip this step',
      btn_restart:         'Take the test again',
      btn_view_cart:       'View my cart \u2192',
      btn_continue_shop:   'Continue shopping',
      btn_add_to_cart:     'Add to cart',
      btn_add_bundle:      'Add bundle to cart',
      btn_adding:          'Adding\u2026',
      btn_added:           'Added \u2713',
      btn_bundle_added:    'Bundle added \u2713',
      btn_error_retry:     'Error, please try again',
      email_placeholder:   'your@email.com',
      marketing_optin:     'I would like to receive tips and offers from MyPureSkin by email. I can unsubscribe at any time.',

      scale_low:           'Not at all',
      scale_high:          'Completely',

      yes:                 'Yes',
      no:                  'No',

      upload_cta:          'Add a photo of your face',
      upload_hint:         'JPG, PNG \u00b7 max 10 MB',
      upload_preview_alt:  'Preview',
      photo_prompt:        'Would you like to add a photo of your face to refine your score?',

      plan_one_time:       'One-time purchase',

      result_hello:        'Hello',
      result_no_name:      'Here are your results,',
      result_subtitle:     'Here is your',
      result_label:        'STRUCTURAL AGING SCORE\u2122',
      result_objective:    'Objective:',
      result_actions:      'What to do',
      reco_badge_label:    'Personalised recommendation',
      reco_badge_sub:      'Based on your Structural Aging Score\u2122 and your unique profile.',
      bundle_label:        'Combined offer',
      bundle_desc_suffix:  '\u2014 add both products in one click.',
    },

    intro: {
      eyebrow:    'Swiss Excellence',
      title:      'Your Structural<br>Aging Score\u2122',
      sub:        'Understand how your biological structure evolves over time, and how to support it.',
      disclaimer: 'This tool is not a medical diagnosis. It aims to contextualise your ageing and promote a proactive healthy ageing approach.',
    },

    consent: {
      title_prefix: 'Welcome',
      intro:        'We will ask you a few questions to suggest a selection of MyPureSkin supplements, personalised to your needs and goals.',
      disclaimer:   'This tool is not a medical diagnosis. It aims to contextualise your ageing and promote a holistic, proactive healthy ageing approach.',
      checkbox:     'By ticking this box, I agree that the personal data I provide to MyPureSkin will be used to create my personalised supplement recommendation.',
    },

    loading: {
      title: 'Calculating your score\u2026',
      steps: [
        'Biological profile analysis',
        'Lifestyle factor assessment',
        'Skin marker calculation',
        'Cross-referencing with clinical data',
        'Personalising recommendations',
        'Score finalised \u2713',
      ],
    },

    nodes: {
      prenom: {
        question:    'What is your<br>name?',
        placeholder: 'Your first name',
      },
      trans_profil: {
        eyebrow:  'Step 1 \u2014 Profile',
        title:    'Let\'s start with<br>your profile.',
        subtitle: 'This information allows us to calculate your reference biological ageing score.',
      },
      age: {
        question: 'How old are you?',
        unit:     'years',
      },
      genre: {
        question: 'What is your sex?',
        options: [
          { label: 'Female' },
          { label: 'Male' },
        ],
      },
      taille: {
        question: 'What is your height?',
      },
      poids: {
        question: 'What is your weight?',
      },
      trans_vie: {
        eyebrow:  'Step 2 \u2014 Lifestyle',
        title:    'Let\'s talk about<br>your lifestyle.',
        subtitle: 'These factors directly influence the pace of biological ageing.',
      },
      tabac: {
        question: 'Do you currently smoke?',
        options: [
          { label: 'No' },
          { label: 'Occasionally' },
          { label: 'Regularly' },
        ],
      },
      alcool: {
        question: 'What is your alcohol consumption?',
        options: [
          { label: 'Rare or never' },
          { label: '1\u20133 times per week' },
          { label: 'More frequently' },
        ],
      },
      stress: {
        question: 'How would you rate your daily stress level?',
        options: [
          { label: 'Low',      sub: 'I feel calm in my daily life' },
          { label: 'Moderate', sub: 'Occasional stress peaks' },
          { label: 'High',     sub: 'Chronic or frequent stress' },
        ],
        whyAsk: {
          title: 'Why we ask this',
          text:  'Chronic stress accelerates cellular ageing by elevating cortisol, directly impacting skin quality and biological tissues.',
        },
      },
      trans_meno: {
        eyebrow:  'Hormonal transitions',
        title:    'Let\'s talk about<br>your hormonal balance.',
        subtitle: 'This information allows us to further personalise your recommendations.',
      },
      meno_concernee: {
        question: 'Are you affected by menopause?',
        options: [
          { label: 'Yes' },
          { label: 'No' },
          { label: 'I don\'t know' },
        ],
      },
      meno_stade: {
        question: 'At what stage are you currently?',
        options: [
          { label: 'Peri-menopause',  sub: 'Irregular cycles, first hormonal changes' },
          { label: 'Pre-menopause',   sub: 'Hormonal symptoms, but periods still present' },
          { label: 'Menopause',       sub: 'No periods for more than 12 months' },
          { label: 'Post-menopause',  sub: 'Hormonal balance stabilised after menopause' },
        ],
      },
      trans_objectifs: {
        eyebrow:  'Step 3 \u2014 Objectives',
        title:    'What are your improvement objectives?',
        subtitle: 'We will personalise our recommendations based on your priorities.',
      },
      objectifs: {
        question: 'What are your main objectives?',
        sub:      'Multiple selection possible',
        options: [
          { label: 'Energy & vitality' },
          { label: 'Facial skin' },
          { label: 'Body skin' },
          { label: 'Hair & nails' },
          { label: 'Stress management' },
          { label: 'Hormonal balance' },
          { label: 'Sports recovery' },
          { label: 'Inflammation reduction' },
          { label: 'Weight loss & cellulite' },
          { label: 'Reduction of biological ageing' },
        ],
      },
      trans_peau: {
        eyebrow:  'Step 4 \u2014 Facial skin',
        title:    'Let\'s analyse your facial skin.',
        subtitle: 'On a scale of 1 to 5, honestly evaluate the changes observed on your skin.',
      },
      peau_densite: {
        question: 'My skin has lost density and firmness over time.',
      },
      peau_marques: {
        question: 'My skin marks more easily than before (wrinkles, folds, signs of fatigue).',
      },
      peau_qualite: {
        question: 'The overall quality of my skin has declined in recent years.',
      },
      photo: {
        question: 'Visual analysis',
        sub:      'Optional but recommended',
        whyAsk: {
          title: 'Why we ask this',
          text:  'This image is analysed using artificial intelligence compared to our clinical data, to better contextualise your skin score. No data is used for diagnostic purposes.',
        },
      },
      trans_energie: {
        eyebrow:  'Step 5 \u2014 Energy & Recovery',
        title:    'Let\'s evaluate your energy<br>and recovery.',
        subtitle: 'These functional indicators reflect your body\'s regeneration capacity.',
      },
      energie_group_a: {
        groupTitle: 'Energy & regeneration',
        items: [
          { question: 'I recover more slowly than a few years ago.' },
          { question: 'Periods of fatigue last longer.' },
          { question: 'I feel like my body regenerates more slowly.' },
        ],
      },
      energie_group_b: {
        groupTitle: 'Resilience & perceived inflammageing',
        items: [
          { question: 'I feel a persistent background fatigue.' },
          { question: 'My body is more sensitive to stress than before.' },
          { question: 'I regularly feel stiffness or heaviness in my body.' },
        ],
      },
      sport: {
        question: 'When I exercise:',
        sub:      'Multiple choices',
        options: [
          { label: 'I recover quickly' },
          { label: 'I often have joint pain' },
          { label: 'I often have muscle pain' },
          { label: 'I feel prolonged fatigue after exercise' },
        ],
      },
      trans_cellulite: {
        eyebrow:  'Step 6 \u2014 Body composition',
        title:    'Diet and<br>body composition.',
        subtitle: 'These elements complete your functional and metabolic profile.',
      },
      alimentation: {
        question: 'My diet is generally balanced.',
      },
      fruits_legumes: {
        question: 'My fruit and vegetable consumption is on average:',
        options: [
          { label: 'Rare or non-existent' },
          { label: '1\u20132 portions per day' },
          { label: 'Every day (3+ portions)' },
        ],
      },
      cellulite_hanches: {
        question: 'Presence of cellulite around the hips?',
      },
      cellulite_jambes: {
        question: 'Visible cellulite on the legs?',
      },
      email: {
        question: 'Last step before your results!',
        sub:      'Enter your email to receive your personalised recommendations.',
      },
    },

    results: {
      homme: {
        repair_contour: {
          statusTitle:    'Weakened structure',
          objective:      'Reinforced support for regeneration and structure',
          interpretation: 'Your biological structure shows signs of advanced weakening. At this stage, the approach must be global and functional: going beyond appearance to support repair mechanisms, recovery, tissue quality and metabolic balance, with a direct impact on body shape, mobility and quality of life.',
          quote:          'At this stage, the challenge goes beyond appearance: it\'s also about supporting functionality, recovery, tissue quality and metabolic balance.',
          quoteAuthor:    'Tatiana Brandt, co-founder of MyPureSkin',
          actions: [
            'Intensively support biological repair mechanisms',
            'Improve recovery capacity and overall resilience',
            'Reduce chronic inflammation and oxidative stress',
            'Preserve inflammatory balance',
            'Support tissue quality, combat cellulite and activate drainage',
            'Promote more harmonious body reshaping',
          ],
        },
        repair: {
          statusTitle:    'Structure to support',
          objective:      'Reinforced regeneration support',
          interpretation: 'Your biological structure is beginning to show signs of progressive weakening. At this stage, the approach must be global: going beyond appearance to support function, recovery capacity and tissue quality, with a direct impact on quality of life.',
          quote:          'At this stage, the challenge goes beyond appearance: it\'s also about supporting functionality, recovery and tissue quality.',
          quoteAuthor:    'Tatiana Brandt, co-founder of MyPureSkin',
          actions: [
            'Intensively support biological repair mechanisms',
            'Improve recovery capacity and overall resilience',
            'Reduce chronic inflammation and oxidative stress',
          ],
        },
        contour: {
          statusTitle:    'Structure to support',
          objective:      'Stabilisation & repair',
          interpretation: 'Biological repair mechanisms are beginning to slow. The priority is to stabilise the existing structure and actively support the natural repair processes.',
          quote:          'The body is progressively losing its repair capacity. Biological mechanisms need to be supported.',
          quoteAuthor:    'Tatiana Brandt, co-founder of MyPureSkin',
          actions: [
            'Slow the acceleration of structural ageing',
            'Support tissue regeneration',
            'Restore skin quality and overall resilience',
            'Preserve inflammatory balance',
            'Combat cellulite and activate drainage',
          ],
        },
        lift: {
          statusTitle:    'Well-preserved structure to maintain',
          objective:      'Prevention & maintenance',
          interpretation: 'Your biological structure is broadly well-preserved. At this stage, the goal is not to correct, but to slow the biological degradation mechanisms linked to ageing, before they become established.',
          quote:          'At this stage, we are not yet correcting. We are preserving the structure.',
          quoteAuthor:    'Tatiana Brandt, co-founder of MyPureSkin',
          actions: [
            'Support skin density',
            'Maintain natural regeneration mechanisms',
            'Preserve inflammatory balance',
          ],
        },
      },

      femme: {
        c1: {
          statusTitle:    'Well-preserved structure to maintain',
          objective:      'Prevention & maintenance',
          interpretation: 'Your biological structure is broadly well-preserved. At this stage, the goal is not to correct, but to slow the biological degradation mechanisms linked to ageing, before they become established.',
          quote:          'At this stage, we are not yet correcting. We are preserving the structure.',
          quoteAuthor:    'Tatiana Brandt, co-founder of MyPureSkin',
          actions: [
            'Support skin density',
            'Maintain natural regeneration mechanisms',
            'Preserve inflammatory balance',
          ],
        },
        c2: {
          statusTitle:    'Well-preserved structure to maintain',
          objective:      'Prevention, maintenance & support for weight loss',
          interpretation: 'Your biological structure is broadly well-preserved. At this stage, it is not about correcting structural degradation, but about preserving the foundations while supporting a reduction in adipose tissue. The goal is to support metabolic functions, tissue quality and tone, to promote more harmonious and lasting weight loss.',
          quote:          'At this stage, we are not yet correcting. We are preserving the structure — while supporting metabolic balance.',
          quoteAuthor:    'Tatiana Brandt, co-founder of MyPureSkin',
          actions: [
            'Preserve tissue density and quality',
            'Maintain natural regeneration mechanisms',
            'Support inflammatory and metabolic balance',
            'Support weight loss without weakening the structure',
            'Promote drainage and body harmony',
          ],
        },
        c3: {
          statusTitle:    'Well-preserved structure to maintain',
          objective:      'Prevention & maintenance',
          interpretation: 'Your biological structure is broadly well-preserved. At this stage, the goal is not to correct, but to slow the biological degradation mechanisms linked to ageing, before they become established.',
          quote:          'At this stage, we are not yet correcting. We are preserving the structure.',
          quoteAuthor:    'Tatiana Brandt, co-founder of MyPureSkin',
          actions: [
            'Support skin density',
            'Maintain natural regeneration mechanisms',
            'Preserve inflammatory balance',
          ],
        },
        c4: {
          statusTitle:    'Well-preserved structure to maintain',
          objective:      'Prevention, maintenance & support for weight loss',
          interpretation: 'Your biological structure is broadly well-preserved. At this stage, it is not about correcting structural degradation, but about preserving the foundations while supporting a reduction in adipose tissue. The goal is to support metabolic functions, tissue quality and tone, to promote more harmonious and lasting weight loss.',
          quote:          'At this stage, we are not yet correcting. We are preserving the structure — while supporting metabolic balance.',
          quoteAuthor:    'Tatiana Brandt, co-founder of MyPureSkin',
          actions: [
            'Preserve tissue density and quality',
            'Maintain natural regeneration mechanisms',
            'Support inflammatory and metabolic balance',
            'Support weight loss without weakening the structure',
            'Promote drainage and body harmony',
          ],
        },
        c5: {
          statusTitle:    'Well-preserved structure to maintain',
          objective:      'Prevention, maintenance & anticipating hormonal changes',
          interpretation: 'Your biological structure is broadly well-preserved. At this stage, the goal is not to correct, but to slow the biological degradation mechanisms linked to ageing, while anticipating the hormonal changes associated with peri-menopause or menopause. This key phase influences tissue quality, inflammation and regeneration capacity, hence the importance of preventive support.',
          quote:          'At this stage, we are not yet correcting. We are preserving the structure.',
          quoteAuthor:    'Tatiana Brandt, co-founder of MyPureSkin',
          actions: [
            'Support tissue density and quality',
            'Maintain natural regeneration mechanisms',
            'Preserve inflammatory balance',
            'Anticipate hormonal impacts on skin and tissue structure',
            'Support the hormonal impacts of menopause',
          ],
        },
        c6: {
          statusTitle:    'Well-preserved structure to maintain',
          objective:      'Prevention, maintenance & anticipating hormonal changes',
          interpretation: 'Your biological structure is broadly well-preserved. At this stage, the goal is not to correct, but to slow the biological degradation mechanisms linked to ageing, while anticipating the hormonal changes associated with peri-menopause or menopause. This key phase can be accompanied by metabolic changes, a tendency to gain weight and changes in fat distribution, while influencing tissue quality, inflammation and regeneration capacity. Preventive support helps preserve structure, body harmony and physical comfort.',
          quote:          'At this stage, we are not yet correcting. We are preserving the structure.',
          quoteAuthor:    'Tatiana Brandt, co-founder of MyPureSkin',
          actions: [
            'Support tissue density and quality',
            'Maintain natural regeneration mechanisms',
            'Preserve inflammatory balance',
            'Anticipate hormonal impacts on skin and tissue structure',
            'Support metabolic balance to limit hormonal weight gain',
            'Promote drainage and limit cellulite formation',
          ],
        },
        c7: {
          statusTitle:    'Structure to support',
          objective:      'Reinforced regeneration support',
          interpretation: 'Your biological structure is beginning to show signs of progressive weakening. At this stage, the approach must be global: going beyond appearance to support function, recovery capacity and tissue quality, with a direct impact on quality of life.',
          quote:          'At this stage, the challenge goes beyond appearance: it\'s also about supporting functionality, recovery and tissue quality.',
          quoteAuthor:    'Tatiana Brandt, co-founder of MyPureSkin',
          actions: [
            'Intensively support biological repair mechanisms',
            'Improve recovery capacity and overall resilience',
            'Reduce chronic inflammation and oxidative stress',
          ],
        },
        c8: {
          statusTitle:    'Weakened structure',
          objective:      'Reinforced support for regeneration and structure',
          interpretation: 'Your biological structure shows signs of advanced weakening. At this stage, the approach must be global and functional: going beyond appearance to support repair mechanisms, recovery, tissue quality and metabolic balance, with a direct impact on body shape, mobility and quality of life.',
          quote:          'At this stage, the challenge goes beyond appearance: it\'s also about supporting functionality, recovery, tissue quality and metabolic balance.',
          quoteAuthor:    'Tatiana Brandt, co-founder of MyPureSkin',
          actions: [
            'Intensively support biological repair mechanisms',
            'Improve recovery capacity and overall resilience',
            'Reduce chronic inflammation and oxidative stress',
            'Preserve inflammatory balance',
            'Support tissue quality, combat cellulite and activate drainage',
            'Promote more harmonious body reshaping',
          ],
        },
      },
    },
  },


  /* ==============================================================
     DEUTSCH
  ============================================================== */
  de: {

    ui: {
      btn_continue:        'Weiter',
      btn_start:           'Test starten',
      btn_see_results:     'Meine Ergebnisse sehen',
      btn_skip_step:       'Diesen Schritt \u00fcberspringen',
      btn_restart:         'Test wiederholen',
      btn_view_cart:       'Warenkorb ansehen \u2192',
      btn_continue_shop:   'Weiter einkaufen',
      btn_add_to_cart:     'In den Warenkorb',
      btn_add_bundle:      'Bundle in den Warenkorb',
      btn_adding:          'Wird hinzugefügt\u2026',
      btn_added:           'Hinzugefügt \u2713',
      btn_bundle_added:    'Bundle hinzugefügt \u2713',
      btn_error_retry:     'Fehler, bitte erneut versuchen',
      email_placeholder:   'ihre@email.com',
      marketing_optin:     'Ich möchte Tipps und Angebote von MyPureSkin per E-Mail erhalten. Abmeldung jederzeit möglich.',

      scale_low:           'Gar nicht',
      scale_high:          'Vollst\u00e4ndig',

      yes:                 'Ja',
      no:                  'Nein',

      upload_cta:          'Foto Ihres Gesichts hinzuf\u00fcgen',
      upload_hint:         'JPG, PNG \u00b7 max. 10 MB',
      upload_preview_alt:  'Vorschau',
      photo_prompt:        'M\u00f6chten Sie ein Foto Ihres Gesichts hinzuf\u00fcgen, um Ihren Score zu verfeinern?',

      plan_one_time:       'Einmaliger Kauf',

      result_hello:        'Hallo',
      result_no_name:      'Hier sind Ihre Ergebnisse,',
      result_subtitle:     'Hier ist Ihr',
      result_label:        'STRUCTURAL AGING SCORE\u2122',
      result_objective:    'Ziel:',
      result_actions:      'Was tun',
      reco_badge_label:    'Pers\u00f6nliche Empfehlung',
      reco_badge_sub:      'Basierend auf Ihrem Structural Aging Score\u2122 und Ihrem einzigartigen Profil.',
      bundle_label:        'Kombinationsangebot',
      bundle_desc_suffix:  '\u2014 f\u00fcgen Sie beide Produkte mit einem Klick hinzu.',
    },

    intro: {
      eyebrow:    'Swiss Excellence',
      title:      'Ihr Structural<br>Aging Score\u2122',
      sub:        'Verstehen Sie, wie sich Ihre biologische Struktur mit der Zeit ver\u00e4ndert, und wie Sie sie unterst\u00fctzen k\u00f6nnen.',
      disclaimer: 'Dieses Tool ist keine medizinische Diagnose. Es dient dazu, Ihre Alterung zu kontextualisieren und einen proaktiven Ansatz f\u00fcr gesundes Altern zu f\u00f6rdern.',
    },

    consent: {
      title_prefix: 'Willkommen',
      intro:        'Wir werden Ihnen einige Fragen stellen, um Ihnen eine auf Ihre Bed\u00fcrfnisse und Ziele zugeschnittene Auswahl an MyPureSkin-Nahrungserg\u00e4nzungsmitteln vorzuschlagen.',
      disclaimer:   'Dieses Tool ist keine medizinische Diagnose. Es dient dazu, Ihre Alterung zu kontextualisieren und einen ganzheitlichen, proaktiven Ansatz f\u00fcr gesundes Altern zu f\u00f6rdern.',
      checkbox:     'Durch Ankreuzen dieses K\u00e4stchens stimme ich zu, dass die pers\u00f6nlichen Daten, die ich MyPureSkin zur Verf\u00fcgung stelle, zur Erstellung meiner pers\u00f6nlichen Nahrungserg\u00e4nzungsempfehlung verwendet werden.',
    },

    loading: {
      title: 'Ihr Score wird<br>berechnet\u2026',
      steps: [
        'Analyse des biologischen Profils',
        'Bewertung der Lebensstilfaktoren',
        'Berechnung der Hautmarker',
        'Abgleich mit klinischen Daten',
        'Personalisierung der Empfehlungen',
        'Score abgeschlossen \u2713',
      ],
    },

    nodes: {
      prenom: {
        question:    'Wie hei\u00dfen<br>Sie?',
        placeholder: 'Ihr Vorname',
      },
      trans_profil: {
        eyebrow:  'Schritt 1 \u2014 Profil',
        title:    'Beginnen wir mit<br>Ihrem Profil.',
        subtitle: 'Diese Informationen erm\u00f6glichen es uns, Ihren biologischen Alterungs-Referenzwert zu berechnen.',
      },
      age: {
        question: 'Wie alt sind Sie?',
        unit:     'Jahre',
      },
      genre: {
        question: 'Was ist Ihr Geschlecht?',
        options: [
          { label: 'Frau' },
          { label: 'Mann' },
        ],
      },
      taille: {
        question: 'Wie gro\u00df sind Sie?',
      },
      poids: {
        question: 'Wie viel wiegen Sie?',
      },
      trans_vie: {
        eyebrow:  'Schritt 2 \u2014 Lebensstil',
        title:    'Sprechen wir \u00fcber<br>Ihren Lebensstil.',
        subtitle: 'Diese Faktoren beeinflussen direkt das Tempo der biologischen Alterung.',
      },
      tabac: {
        question: 'Rauchen Sie derzeit?',
        options: [
          { label: 'Nein' },
          { label: 'Gelegentlich' },
          { label: 'Regelm\u00e4\u00dfig' },
        ],
      },
      alcool: {
        question: 'Wie viel Alkohol trinken Sie?',
        options: [
          { label: 'Selten oder nie' },
          { label: '1\u20133 Mal pro Woche' },
          { label: 'H\u00e4ufiger' },
        ],
      },
      stress: {
        question: 'Wie sch\u00e4tzen Sie Ihr t\u00e4gliches Stressniveau ein?',
        options: [
          { label: 'Niedrig',  sub: 'Ich f\u00fchle mich im Alltag entspannt' },
          { label: 'Moderat',  sub: 'Gelegentliche Stressphasen' },
          { label: 'Hoch',     sub: 'Chronischer oder h\u00e4ufiger Stress' },
        ],
        whyAsk: {
          title: 'Warum wir das fragen',
          text:  'Chronischer Stress beschleunigt die zellul\u00e4re Alterung durch einen erh\u00f6hten Cortisolspiegel und beeintr\u00e4chtigt direkt die Haut- und Gewebequalit\u00e4t.',
        },
      },
      trans_meno: {
        eyebrow:  'Hormonelle \u00dcberg\u00e4nge',
        title:    'Sprechen wir \u00fcber<br>Ihr Hormongleichgewicht.',
        subtitle: 'Diese Informationen erm\u00f6glichen uns, Ihre Empfehlungen weiter zu personalisieren.',
      },
      meno_concernee: {
        question: 'Sind Sie von der Menopause betroffen?',
        options: [
          { label: 'Ja' },
          { label: 'Nein' },
          { label: 'Ich wei\u00df es nicht' },
        ],
      },
      meno_stade: {
        question: 'In welchem Stadium befinden Sie sich derzeit?',
        options: [
          { label: 'Perimenopause',   sub: 'Unregelm\u00e4\u00dfige Zyklen, erste hormonelle Ver\u00e4nderungen' },
          { label: 'Pr\u00e4menopause',   sub: 'Hormonelle Symptome, aber Menstruation noch vorhanden' },
          { label: 'Menopause',       sub: 'Keine Menstruation seit mehr als 12 Monaten' },
          { label: 'Postmenopause',   sub: 'Hormonelles Gleichgewicht nach der Menopause stabilisiert' },
        ],
      },
      trans_objectifs: {
        eyebrow:  'Schritt 3 \u2014 Ziele',
        title:    'Was sind Ihre Verbesserungsziele?',
        subtitle: 'Wir personalisieren unsere Empfehlungen basierend auf Ihren Priorit\u00e4ten.',
      },
      objectifs: {
        question: 'Was sind Ihre Hauptziele?',
        sub:      'Mehrfachauswahl m\u00f6glich',
        options: [
          { label: 'Energie & Vitalit\u00e4t' },
          { label: 'Gesichtshaut' },
          { label: 'K\u00f6rperhaut' },
          { label: 'Haare & N\u00e4gel' },
          { label: 'Stressmanagement' },
          { label: 'Hormonelles Gleichgewicht' },
          { label: 'Sportliche Erholung' },
          { label: 'Entz\u00fcndungsreduktion' },
          { label: 'Gewichtsverlust & Cellulite' },
          { label: 'Reduzierung der biologischen Alterung' },
        ],
      },
      trans_peau: {
        eyebrow:  'Schritt 4 \u2014 Gesichtshaut',
        title:    'Analysieren wir Ihre Gesichtshaut.',
        subtitle: 'Bewerten Sie auf einer Skala von 1 bis 5 ehrlich die Ver\u00e4nderungen, die Sie an Ihrer Haut beobachten.',
      },
      peau_densite: {
        question: 'Meine Haut hat mit der Zeit an Dichte und Festigkeit verloren.',
      },
      peau_marques: {
        question: 'Meine Haut zeigt leichter als fr\u00fcher Abdr\u00fccke (Falten, Linien, M\u00fcdigkeitszeichen).',
      },
      peau_qualite: {
        question: 'Die allgemeine Qualit\u00e4t meiner Haut hat sich in den letzten Jahren verschlechtert.',
      },
      photo: {
        question: 'Visuelle Analyse',
        sub:      'Optional, aber empfohlen',
        whyAsk: {
          title: 'Warum wir das fragen',
          text:  'Dieses Bild wird mithilfe k\u00fcnstlicher Intelligenz mit unseren klinischen Daten verglichen, um Ihren Hautscore besser zu kontextualisieren. Es werden keine Daten f\u00fcr diagnostische Zwecke verwendet.',
        },
      },
      trans_energie: {
        eyebrow:  'Schritt 5 \u2014 Energie & Erholung',
        title:    'Bewerten wir Ihre Energie<br>und Erholung.',
        subtitle: 'Diese Funktionsindikatoren spiegeln die Regenerationsf\u00e4higkeit Ihres K\u00f6rpers wider.',
      },
      energie_group_a: {
        groupTitle: 'Energie & Regeneration',
        items: [
          { question: 'Ich erhole mich langsamer als vor einigen Jahren.' },
          { question: 'M\u00fcdigkeitsphasen dauern l\u00e4nger.' },
          { question: 'Ich habe das Gef\u00fchl, dass mein K\u00f6rper sich langsamer regeneriert.' },
        ],
      },
      energie_group_b: {
        groupTitle: 'Resilienz & wahrgenommenes Inflammaging',
        items: [
          { question: 'Ich f\u00fchle eine anhaltende Grundm\u00fcdigkeit.' },
          { question: 'Mein K\u00f6rper ist empfindlicher gegen\u00fcber Stress als fr\u00fcher.' },
          { question: 'Ich versp\u00fcre regelm\u00e4\u00dfig Steifheit oder Schwere im K\u00f6rper.' },
        ],
      },
      sport: {
        question: 'Wenn ich Sport treibe:',
        sub:      'Mehrfachauswahl',
        options: [
          { label: 'Ich erhole mich schnell' },
          { label: 'Ich habe oft Gelenkschmerzen' },
          { label: 'Ich habe oft Muskelschmerzen' },
          { label: 'Ich f\u00fchle anhaltende M\u00fcdigkeit nach der Anstrengung' },
        ],
      },
      trans_cellulite: {
        eyebrow:  'Schritt 6 \u2014 K\u00f6rperzusammensetzung',
        title:    'Ern\u00e4hrung und<br>K\u00f6rperzusammensetzung.',
        subtitle: 'Diese Elemente vervollst\u00e4ndigen Ihr funktionelles und metabolisches Profil.',
      },
      alimentation: {
        question: 'Meine Ern\u00e4hrung ist insgesamt ausgewogen.',
      },
      fruits_legumes: {
        question: 'Mein Obst- und Gem\u00fcseverbrauch betr\u00e4gt im Durchschnitt:',
        options: [
          { label: 'Selten oder gar nicht' },
          { label: '1\u20132 Portionen pro Tag' },
          { label: 'T\u00e4glich (3+ Portionen)' },
        ],
      },
      cellulite_hanches: {
        question: 'Cellulite im Bereich der H\u00fcften?',
      },
      cellulite_jambes: {
        question: 'Sichtbare Cellulite an den Beinen?',
      },
      email: {
        question: 'Letzter Schritt vor Ihren Ergebnissen!',
        sub:      'Geben Sie Ihre E-Mail-Adresse ein, um Ihre personalisierten Empfehlungen zu erhalten.',
      },
    },

    results: {
      homme: {
        repair_contour: {
          statusTitle:    'Geschw\u00e4chte Struktur',
          objective:      'Verst\u00e4rkte Unterst\u00fctzung der Regeneration und Struktur',
          interpretation: 'Ihre biologische Struktur zeigt Anzeichen einer fortgeschrittenen Schw\u00e4chung. In diesem Stadium muss der Ansatz global und funktional sein: \u00fcber das \u00c4u\u00dfere hinausgehen, um Reparaturmechanismen, Erholung, Gewebequalit\u00e4t und metabolisches Gleichgewicht zu unterst\u00fctzen, mit direktem Einfluss auf K\u00f6rperform, Mobilit\u00e4t und Lebensqualit\u00e4t.',
          quote:          'In diesem Stadium geht die Herausforderung \u00fcber das \u00c4u\u00dfere hinaus: Es geht auch darum, Funktionalit\u00e4t, Erholung, Gewebequalit\u00e4t und metabolisches Gleichgewicht zu unterst\u00fctzen.',
          quoteAuthor:    'Tatiana Brandt, Mitgr\u00fcnderin von MyPureSkin',
          actions: [
            'Biologische Reparaturmechanismen intensiv unterst\u00fctzen',
            'Erholungsf\u00e4higkeit und allgemeine Resilienz verbessern',
            'Chronische Entz\u00fcndungen und oxidativen Stress reduzieren',
            'Entz\u00fcndliches Gleichgewicht bewahren',
            'Gewebequalit\u00e4t unterst\u00fctzen, Cellulite bek\u00e4mpfen und Drainage aktivieren',
            'Eine harmonischere K\u00f6rperformung f\u00f6rdern',
          ],
        },
        repair: {
          statusTitle:    'Zu unterst\u00fctzende Struktur',
          objective:      'Verst\u00e4rkte Regenerationsunterst\u00fctzung',
          interpretation: 'Ihre biologische Struktur beginnt Anzeichen einer fortschreitenden Schw\u00e4chung zu zeigen. In diesem Stadium muss der Ansatz global sein: \u00fcber das \u00c4u\u00dfere hinausgehen, um Funktion, Erholungsf\u00e4higkeit und Gewebequalit\u00e4t zu unterst\u00fctzen, mit direktem Einfluss auf die Lebensqualit\u00e4t.',
          quote:          'In diesem Stadium geht die Herausforderung \u00fcber das \u00c4u\u00dfere hinaus: Es geht auch darum, Funktionalit\u00e4t, Erholung und Gewebequalit\u00e4t zu unterst\u00fctzen.',
          quoteAuthor:    'Tatiana Brandt, Mitgr\u00fcnderin von MyPureSkin',
          actions: [
            'Biologische Reparaturmechanismen intensiv unterst\u00fctzen',
            'Erholungsf\u00e4higkeit und allgemeine Resilienz verbessern',
            'Chronische Entz\u00fcndungen und oxidativen Stress reduzieren',
          ],
        },
        contour: {
          statusTitle:    'Zu unterst\u00fctzende Struktur',
          objective:      'Stabilisierung & Reparatur',
          interpretation: 'Die biologischen Reparaturmechanismen beginnen zu verlangsamen. Die Priorit\u00e4t besteht darin, die bestehende Struktur zu stabilisieren und die nat\u00fcrlichen Reparaturprozesse aktiv zu unterst\u00fctzen.',
          quote:          'Der K\u00f6rper verliert schrittweise seine Reparaturf\u00e4higkeit. Biologische Mechanismen m\u00fcssen unterst\u00fctzt werden.',
          quoteAuthor:    'Tatiana Brandt, Mitgr\u00fcnderin von MyPureSkin',
          actions: [
            'Die Beschleunigung der strukturellen Alterung verlangsamen',
            'Geweberegeneration unterst\u00fctzen',
            'Hautqualit\u00e4t und allgemeine Resilienz wiederherstellen',
            'Entz\u00fcndliches Gleichgewicht bewahren',
            'Cellulite bek\u00e4mpfen und Drainage aktivieren',
          ],
        },
        lift: {
          statusTitle:    'Gut erhaltene Struktur zu pflegen',
          objective:      'Pr\u00e4vention & Erhaltung',
          interpretation: 'Ihre biologische Struktur ist allgemein gut erhalten. In diesem Stadium geht es nicht darum zu korrigieren, sondern die biologischen Abbauprozesse des Alterns zu verlangsamen, bevor sie sich etablieren.',
          quote:          'In diesem Stadium korrigieren wir noch nicht. Wir erhalten die Struktur.',
          quoteAuthor:    'Tatiana Brandt, Mitgr\u00fcnderin von MyPureSkin',
          actions: [
            'Hautdichte unterst\u00fctzen',
            'Nat\u00fcrliche Regenerationsmechanismen aufrechterhalten',
            'Entz\u00fcndliches Gleichgewicht bewahren',
          ],
        },
      },

      femme: {
        c1: {
          statusTitle:    'Gut erhaltene Struktur zu pflegen',
          objective:      'Pr\u00e4vention & Erhaltung',
          interpretation: 'Ihre biologische Struktur ist allgemein gut erhalten. In diesem Stadium geht es nicht darum zu korrigieren, sondern die biologischen Abbauprozesse des Alterns zu verlangsamen, bevor sie sich etablieren.',
          quote:          'In diesem Stadium korrigieren wir noch nicht. Wir erhalten die Struktur.',
          quoteAuthor:    'Tatiana Brandt, Mitgr\u00fcnderin von MyPureSkin',
          actions: [
            'Hautdichte unterst\u00fctzen',
            'Nat\u00fcrliche Regenerationsmechanismen aufrechterhalten',
            'Entz\u00fcndliches Gleichgewicht bewahren',
          ],
        },
        c2: {
          statusTitle:    'Gut erhaltene Struktur zu pflegen',
          objective:      'Pr\u00e4vention, Erhaltung & Unterst\u00fctzung der Gewichtsabnahme',
          interpretation: 'Ihre biologische Struktur ist allgemein gut erhalten. In diesem Stadium geht es nicht darum, einen strukturellen Abbau zu korrigieren, sondern die Grundlagen zu bewahren und gleichzeitig eine Reduzierung des Fettgewebes zu unterst\u00fctzen. Das Ziel ist es, Stoffwechselfunktionen, Gewebequalit\u00e4t und Tonus zu unterst\u00fctzen, um eine harmonischere und nachhaltigere Gewichtsabnahme zu f\u00f6rdern.',
          quote:          'In diesem Stadium korrigieren wir noch nicht. Wir erhalten die Struktur \u2014 und unterst\u00fctzen gleichzeitig das metabolische Gleichgewicht.',
          quoteAuthor:    'Tatiana Brandt, Mitgr\u00fcnderin von MyPureSkin',
          actions: [
            'Gewebedichte und -qualit\u00e4t bewahren',
            'Nat\u00fcrliche Regenerationsmechanismen aufrechterhalten',
            'Entz\u00fcndliches und metabolisches Gleichgewicht unterst\u00fctzen',
            'Gewichtsabnahme ohne Schw\u00e4chung der Struktur unterst\u00fctzen',
            'Drainage und K\u00f6rperharmonie f\u00f6rdern',
          ],
        },
        c3: {
          statusTitle:    'Gut erhaltene Struktur zu pflegen',
          objective:      'Pr\u00e4vention & Erhaltung',
          interpretation: 'Ihre biologische Struktur ist allgemein gut erhalten. In diesem Stadium geht es nicht darum zu korrigieren, sondern die biologischen Abbauprozesse des Alterns zu verlangsamen, bevor sie sich etablieren.',
          quote:          'In diesem Stadium korrigieren wir noch nicht. Wir erhalten die Struktur.',
          quoteAuthor:    'Tatiana Brandt, Mitgr\u00fcnderin von MyPureSkin',
          actions: [
            'Hautdichte unterst\u00fctzen',
            'Nat\u00fcrliche Regenerationsmechanismen aufrechterhalten',
            'Entz\u00fcndliches Gleichgewicht bewahren',
          ],
        },
        c4: {
          statusTitle:    'Gut erhaltene Struktur zu pflegen',
          objective:      'Pr\u00e4vention, Erhaltung & Unterst\u00fctzung der Gewichtsabnahme',
          interpretation: 'Ihre biologische Struktur ist allgemein gut erhalten. In diesem Stadium geht es nicht darum, einen strukturellen Abbau zu korrigieren, sondern die Grundlagen zu bewahren und gleichzeitig eine Reduzierung des Fettgewebes zu unterst\u00fctzen. Das Ziel ist es, Stoffwechselfunktionen, Gewebequalit\u00e4t und Tonus zu unterst\u00fctzen, um eine harmonischere und nachhaltigere Gewichtsabnahme zu f\u00f6rdern.',
          quote:          'In diesem Stadium korrigieren wir noch nicht. Wir erhalten die Struktur \u2014 und unterst\u00fctzen gleichzeitig das metabolische Gleichgewicht.',
          quoteAuthor:    'Tatiana Brandt, Mitgr\u00fcnderin von MyPureSkin',
          actions: [
            'Gewebedichte und -qualit\u00e4t bewahren',
            'Nat\u00fcrliche Regenerationsmechanismen aufrechterhalten',
            'Entz\u00fcndliches und metabolisches Gleichgewicht unterst\u00fctzen',
            'Gewichtsabnahme ohne Schw\u00e4chung der Struktur unterst\u00fctzen',
            'Drainage und K\u00f6rperharmonie f\u00f6rdern',
          ],
        },
        c5: {
          statusTitle:    'Gut erhaltene Struktur zu pflegen',
          objective:      'Pr\u00e4vention, Erhaltung & Antizipation hormoneller Ver\u00e4nderungen',
          interpretation: 'Ihre biologische Struktur ist allgemein gut erhalten. In diesem Stadium geht es nicht darum zu korrigieren, sondern die biologischen Abbauprozesse des Alterns zu verlangsamen und gleichzeitig die hormonellen Ver\u00e4nderungen der Peri- oder Menopause zu antizipieren. Diese Schl\u00fcsselphase beeinflusst Gewebequalit\u00e4t, Entz\u00fcndungen und Regenerationsf\u00e4higkeit, daher die Bedeutung einer pr\u00e4ventiven Unterst\u00fctzung.',
          quote:          'In diesem Stadium korrigieren wir noch nicht. Wir erhalten die Struktur.',
          quoteAuthor:    'Tatiana Brandt, Mitgr\u00fcnderin von MyPureSkin',
          actions: [
            'Gewebedichte und -qualit\u00e4t unterst\u00fctzen',
            'Nat\u00fcrliche Regenerationsmechanismen aufrechterhalten',
            'Entz\u00fcndliches Gleichgewicht bewahren',
            'Hormonelle Auswirkungen auf Haut- und Gewebestruktur antizipieren',
            'Die hormonellen Auswirkungen der Menopause unterst\u00fctzen',
          ],
        },
        c6: {
          statusTitle:    'Gut erhaltene Struktur zu pflegen',
          objective:      'Pr\u00e4vention, Erhaltung & Antizipation hormoneller Ver\u00e4nderungen',
          interpretation: 'Ihre biologische Struktur ist allgemein gut erhalten. In diesem Stadium geht es nicht darum zu korrigieren, sondern die biologischen Abbauprozesse des Alterns zu verlangsamen und gleichzeitig die hormonellen Ver\u00e4nderungen der Peri- oder Menopause zu antizipieren. Diese Schl\u00fcsselphase kann von Stoffwechselver\u00e4nderungen, Gewichtszunahme und Ver\u00e4nderungen in der Fettverteilung begleitet werden, w\u00e4hrend sie Gewebequalit\u00e4t, Entz\u00fcndungen und Regenerationsf\u00e4higkeit beeinflusst. Eine pr\u00e4ventive Unterst\u00fctzung hilft, Struktur, K\u00f6rperharmonie und k\u00f6rperlichen Komfort zu bewahren.',
          quote:          'In diesem Stadium korrigieren wir noch nicht. Wir erhalten die Struktur.',
          quoteAuthor:    'Tatiana Brandt, Mitgr\u00fcnderin von MyPureSkin',
          actions: [
            'Gewebedichte und -qualit\u00e4t unterst\u00fctzen',
            'Nat\u00fcrliche Regenerationsmechanismen aufrechterhalten',
            'Entz\u00fcndliches Gleichgewicht bewahren',
            'Hormonelle Auswirkungen auf Haut- und Gewebestruktur antizipieren',
            'Metabolisches Gleichgewicht unterst\u00fctzen, um hormonelle Gewichtszunahme zu begrenzen',
            'Drainage f\u00f6rdern und Cellulite-Bildung begrenzen',
          ],
        },
        c7: {
          statusTitle:    'Zu unterst\u00fctzende Struktur',
          objective:      'Verst\u00e4rkte Regenerationsunterst\u00fctzung',
          interpretation: 'Ihre biologische Struktur beginnt Anzeichen einer fortschreitenden Schw\u00e4chung zu zeigen. In diesem Stadium muss der Ansatz global sein: \u00fcber das \u00c4u\u00dfere hinausgehen, um Funktion, Erholungsf\u00e4higkeit und Gewebequalit\u00e4t zu unterst\u00fctzen, mit direktem Einfluss auf die Lebensqualit\u00e4t.',
          quote:          'In diesem Stadium geht die Herausforderung \u00fcber das \u00c4u\u00dfere hinaus: Es geht auch darum, Funktionalit\u00e4t, Erholung und Gewebequalit\u00e4t zu unterst\u00fctzen.',
          quoteAuthor:    'Tatiana Brandt, Mitgr\u00fcnderin von MyPureSkin',
          actions: [
            'Biologische Reparaturmechanismen intensiv unterst\u00fctzen',
            'Erholungsf\u00e4higkeit und allgemeine Resilienz verbessern',
            'Chronische Entz\u00fcndungen und oxidativen Stress reduzieren',
          ],
        },
        c8: {
          statusTitle:    'Geschw\u00e4chte Struktur',
          objective:      'Verst\u00e4rkte Unterst\u00fctzung der Regeneration und Struktur',
          interpretation: 'Ihre biologische Struktur zeigt Anzeichen einer fortgeschrittenen Schw\u00e4chung. In diesem Stadium muss der Ansatz global und funktional sein: \u00fcber das \u00c4u\u00dfere hinausgehen, um Reparaturmechanismen, Erholung, Gewebequalit\u00e4t und metabolisches Gleichgewicht zu unterst\u00fctzen, mit direktem Einfluss auf K\u00f6rperform, Mobilit\u00e4t und Lebensqualit\u00e4t.',
          quote:          'In diesem Stadium geht die Herausforderung \u00fcber das \u00c4u\u00dfere hinaus: Es geht auch darum, Funktionalit\u00e4t, Erholung, Gewebequalit\u00e4t und metabolisches Gleichgewicht zu unterst\u00fctzen.',
          quoteAuthor:    'Tatiana Brandt, Mitgr\u00fcnderin von MyPureSkin',
          actions: [
            'Biologische Reparaturmechanismen intensiv unterst\u00fctzen',
            'Erholungsf\u00e4higkeit und allgemeine Resilienz verbessern',
            'Chronische Entz\u00fcndungen und oxidativen Stress reduzieren',
            'Entz\u00fcndliches Gleichgewicht bewahren',
            'Gewebequalit\u00e4t unterst\u00fctzen, Cellulite bek\u00e4mpfen und Drainage aktivieren',
            'Eine harmonischere K\u00f6rperformung f\u00f6rdern',
          ],
        },
      },
    },
  },


  /* ==============================================================
     ITALIANO
  ============================================================== */
  it: {

    ui: {
      btn_continue:        'Continua',
      btn_start:           'Inizia il test',
      btn_see_results:     'Vedi i miei risultati',
      btn_skip_step:       'Salta questo passaggio',
      btn_restart:         'Rifare il test',
      btn_view_cart:       'Vedi il mio carrello \u2192',
      btn_continue_shop:   'Continua gli acquisti',
      btn_add_to_cart:     'Aggiungi al carrello',
      btn_add_bundle:      'Aggiungi il bundle al carrello',
      btn_adding:          'Aggiunta in corso\u2026',
      btn_added:           'Aggiunto \u2713',
      btn_bundle_added:    'Bundle aggiunto \u2713',
      btn_error_retry:     'Errore, riprovi',
      email_placeholder:   'nome@email.com',
      marketing_optin:     'Desidero ricevere via e-mail consigli e offerte di MyPureSkin. Posso annullare l\u2019iscrizione in qualsiasi momento.',

      scale_low:           'Per niente',
      scale_high:          'Completamente',

      yes:                 'S\u00ec',
      no:                  'No',

      upload_cta:          'Aggiungere una foto del vostro viso',
      upload_hint:         'JPG, PNG \u00b7 max 10 MB',
      upload_preview_alt:  'Anteprima',
      photo_prompt:        'Desidera aggiungere una foto del suo viso per perfezionare il suo punteggio?',

      plan_one_time:       'Acquisto unico',

      result_hello:        'Buongiorno',
      result_no_name:      'Ecco i suoi risultati,',
      result_subtitle:     'Ecco il suo',
      result_label:        'STRUCTURAL AGING SCORE\u2122',
      result_objective:    'Obiettivo:',
      result_actions:      'Cosa fare',
      reco_badge_label:    'Raccomandazione personalizzata',
      reco_badge_sub:      'Basata sul suo Structural Aging Score\u2122 e sul suo profilo unico.',
      bundle_label:        'Offerta combinata',
      bundle_desc_suffix:  '\u2014 aggiunga entrambi i prodotti in un clic.',
    },

    intro: {
      eyebrow:    'Swiss Excellence',
      title:      'Il suo Structural<br>Aging Score\u2122',
      sub:        'Capire come la sua struttura biologica evolve nel tempo, e come sostenerla.',
      disclaimer: 'Questo strumento non \u00e8 una diagnosi medica. Mira a contestualizzare il suo invecchiamento e a promuovere un approccio proattivo all\u2019healthy aging.',
    },

    consent: {
      title_prefix: 'Benvenuto/a',
      intro:        'Le porr\u00e0 alcune domande per suggerirle una selezione di integratori MyPureSkin, personalizzata secondo i suoi bisogni e obiettivi.',
      disclaimer:   'Questo strumento non \u00e8 una diagnosi medica. Mira a contestualizzare il suo invecchiamento e a promuovere un approccio olistico e proattivo all\u2019healthy aging.',
      checkbox:     'Spuntando questa casella, accetto che i dati personali che fornisco a MyPureSkin vengano utilizzati per creare la mia raccomandazione personalizzata di integratori.',
    },

    loading: {
      title: 'Calcolo del suo punteggio<br>in corso\u2026',
      steps: [
        'Analisi del profilo biologico',
        'Valutazione dei fattori dello stile di vita',
        'Calcolo dei marker cutanei',
        'Confronto con i dati clinici',
        'Personalizzazione delle raccomandazioni',
        'Punteggio finalizzato \u2713',
      ],
    },

    nodes: {
      prenom: {
        question:    'Come si<br>chiama?',
        placeholder: 'Il suo nome',
      },
      trans_profil: {
        eyebrow:  'Fase 1 \u2014 Profilo',
        title:    'Iniziamo con<br>il suo profilo.',
        subtitle: 'Queste informazioni ci permettono di calcolare il suo punteggio di riferimento per l\u2019invecchiamento biologico.',
      },
      age: {
        question: 'Quanti anni ha?',
        unit:     'anni',
      },
      genre: {
        question: 'Qual \u00e8 il suo sesso?',
        options: [
          { label: 'Donna' },
          { label: 'Uomo' },
        ],
      },
      taille: {
        question: 'Qual \u00e8 la sua altezza?',
      },
      poids: {
        question: 'Qual \u00e8 il suo peso?',
      },
      trans_vie: {
        eyebrow:  'Fase 2 \u2014 Stile di vita',
        title:    'Parliamo del suo<br>stile di vita.',
        subtitle: 'Questi fattori influenzano direttamente il ritmo dell\u2019invecchiamento biologico.',
      },
      tabac: {
        question: 'Fuma attualmente?',
        options: [
          { label: 'No' },
          { label: 'Occasionalmente' },
          { label: 'Regolarmente' },
        ],
      },
      alcool: {
        question: 'Qual \u00e8 il suo consumo di alcol?',
        options: [
          { label: 'Raro o mai' },
          { label: '1\u20133 volte a settimana' },
          { label: 'Pi\u00f9 frequentemente' },
        ],
      },
      stress: {
        question: 'Come valuta il suo livello di stress quotidiano?',
        options: [
          { label: 'Basso',    sub: 'Mi sento sereno/a nella vita quotidiana' },
          { label: 'Moderato', sub: 'Picchi di stress occasionali' },
          { label: 'Alto',     sub: 'Stress cronico o frequente' },
        ],
        whyAsk: {
          title: 'Perch\u00e9 lo chiediamo',
          text:  'Lo stress cronico accelera l\u2019invecchiamento cellulare attraverso l\u2019aumento del cortisolo, impattando direttamente la qualit\u00e0 della pelle e dei tessuti biologici.',
        },
      },
      trans_meno: {
        eyebrow:  'Transizioni ormonali',
        title:    'Parliamo del suo<br>equilibrio ormonale.',
        subtitle: 'Queste informazioni ci permettono di personalizzare ulteriormente le sue raccomandazioni.',
      },
      meno_concernee: {
        question: '\u00c8 interessata dalla menopausa?',
        options: [
          { label: 'S\u00ec' },
          { label: 'No' },
          { label: 'Non lo so' },
        ],
      },
      meno_stade: {
        question: 'A che stadio si trova attualmente?',
        options: [
          { label: 'Peri-menopausa',  sub: 'Cicli irregolari, primi cambiamenti ormonali' },
          { label: 'Pre-menopausa',   sub: 'Sintomi ormonali, ma mestruazioni ancora presenti' },
          { label: 'Menopausa',       sub: 'Assenza di mestruazioni da pi\u00f9 di 12 mesi' },
          { label: 'Post-menopausa',  sub: 'Equilibrio ormonale stabilizzato dopo la menopausa' },
        ],
      },
      trans_objectifs: {
        eyebrow:  'Fase 3 \u2014 Obiettivi',
        title:    'Quali sono i suoi obiettivi di miglioramento?',
        subtitle: 'Personalizzeremo le nostre raccomandazioni in base alle sue priorit\u00e0.',
      },
      objectifs: {
        question: 'Quali sono i suoi obiettivi principali?',
        sub:      'Selezione multipla possibile',
        options: [
          { label: 'Energia & vitalit\u00e0' },
          { label: 'Pelle del viso' },
          { label: 'Pelle del corpo' },
          { label: 'Capelli & unghie' },
          { label: 'Gestione dello stress' },
          { label: 'Equilibrio ormonale' },
          { label: 'Recupero sportivo' },
          { label: 'Riduzione dell\u2019infiammazione' },
          { label: 'Perdita di peso & cellulite' },
          { label: 'Riduzione dell\u2019invecchiamento biologico' },
        ],
      },
      trans_peau: {
        eyebrow:  'Fase 4 \u2014 Pelle del viso',
        title:    'Analizziamo la sua pelle del viso.',
        subtitle: 'Su una scala da 1 a 5, valuti onestamente i cambiamenti osservati sulla sua pelle.',
      },
      peau_densite: {
        question: 'La mia pelle ha perso densit\u00e0 e compattezza nel tempo.',
      },
      peau_marques: {
        question: 'La mia pelle si segna pi\u00f9 facilmente di prima (rughe, pieghe, segni di stanchezza).',
      },
      peau_qualite: {
        question: 'La qualit\u00e0 complessiva della mia pelle \u00e8 peggiorata negli ultimi anni.',
      },
      photo: {
        question: 'Analisi visiva',
        sub:      'Opzionale ma consigliata',
        whyAsk: {
          title: 'Perch\u00e9 lo chiediamo',
          text:  'Questa immagine viene analizzata con intelligenza artificiale confrontata con i nostri dati clinici, per contestualizzare meglio il suo punteggio cutaneo. Nessun dato viene utilizzato a scopo diagnostico.',
        },
      },
      trans_energie: {
        eyebrow:  'Fase 5 \u2014 Energia & Recupero',
        title:    'Valutiamo la sua energia<br>e il suo recupero.',
        subtitle: 'Questi indicatori funzionali riflettono la capacit\u00e0 di rigenerazione del suo organismo.',
      },
      energie_group_a: {
        groupTitle: 'Energia & rigenerazione',
        items: [
          { question: 'Mi riprendo pi\u00f9 lentamente di qualche anno fa.' },
          { question: 'I periodi di stanchezza durano pi\u00f9 a lungo.' },
          { question: 'Ho la sensazione che il mio corpo si rigeneri pi\u00f9 lentamente.' },
        ],
      },
      energie_group_b: {
        groupTitle: 'Resilienza & inflammaging percepito',
        items: [
          { question: 'Sento una stanchezza di fondo persistente.' },
          { question: 'Il mio corpo \u00e8 pi\u00f9 sensibile allo stress di prima.' },
          { question: 'Ho regolarmente una sensazione di rigidit\u00e0 o pesantezza corporea.' },
        ],
      },
      sport: {
        question: 'Quando faccio sport:',
        sub:      'Scelte multiple',
        options: [
          { label: 'Mi riprendo rapidamente' },
          { label: 'Ho spesso dolori articolari' },
          { label: 'Ho spesso dolori muscolari' },
          { label: 'Sento una stanchezza prolungata dopo lo sforzo' },
        ],
      },
      trans_cellulite: {
        eyebrow:  'Fase 6 \u2014 Composizione corporea',
        title:    'Alimentazione e<br>composizione corporea.',
        subtitle: 'Questi elementi completano il suo profilo funzionale e metabolico.',
      },
      alimentation: {
        question: 'La mia alimentazione \u00e8 generalmente equilibrata.',
      },
      fruits_legumes: {
        question: 'Il mio consumo di frutta e verdura \u00e8 in media:',
        options: [
          { label: 'Raro o inesistente' },
          { label: '1\u20132 porzioni al giorno' },
          { label: 'Ogni giorno (3+ porzioni)' },
        ],
      },
      cellulite_hanches: {
        question: 'Presenza di cellulite a livello dei fianchi?',
      },
      cellulite_jambes: {
        question: 'Cellulite visibile a livello delle gambe?',
      },
      email: {
        question: 'Ultimo passaggio prima dei suoi risultati!',
        sub:      'Inserisca la sua email per ricevere le sue raccomandazioni personalizzate.',
      },
    },

    results: {
      homme: {
        repair_contour: {
          statusTitle:    'Struttura indebolita',
          objective:      'Supporto rinforzato alla rigenerazione e alla struttura',
          interpretation: 'La sua struttura biologica mostra segni di indebolimento avanzato. In questa fase, l\u2019approccio deve essere globale e funzionale: andare oltre l\u2019apparenza per sostenere i meccanismi di riparazione, il recupero, la qualit\u00e0 dei tessuti e l\u2019equilibrio metabolico, con un impatto diretto sulla silhouette, la mobilit\u00e0 e la qualit\u00e0 della vita.',
          quote:          'In questa fase, la sfida va oltre l\u2019apparenza: si tratta anche di sostenere la funzionalit\u00e0, il recupero, la qualit\u00e0 dei tessuti e l\u2019equilibrio metabolico.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice di MyPureSkin',
          actions: [
            'Sostenere intensamente i meccanismi biologici di riparazione',
            'Migliorare la capacit\u00e0 di recupero e la resilienza globale',
            'Ridurre l\u2019infiammazione cronica e lo stress ossidativo',
            'Preservare l\u2019equilibrio infiammatorio',
            'Sostenere la qualit\u00e0 dei tessuti, combattere la cellulite e attivare il drenaggio',
            'Favorire un rimodellamento pi\u00f9 armonioso della silhouette',
          ],
        },
        repair: {
          statusTitle:    'Struttura da sostenere',
          objective:      'Supporto rinforzato alla rigenerazione',
          interpretation: 'La sua struttura biologica inizia a mostrare segni di indebolimento progressivo. In questa fase, l\u2019approccio deve essere globale: andare oltre l\u2019apparenza per sostenere la funzione, la capacit\u00e0 di recupero e la qualit\u00e0 dei tessuti, con un impatto diretto sulla qualit\u00e0 della vita.',
          quote:          'In questa fase, la sfida va oltre l\u2019apparenza: si tratta anche di sostenere la funzionalit\u00e0, il recupero e la qualit\u00e0 dei tessuti.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice di MyPureSkin',
          actions: [
            'Sostenere intensamente i meccanismi biologici di riparazione',
            'Migliorare la capacit\u00e0 di recupero e la resilienza globale',
            'Ridurre l\u2019infiammazione cronica e lo stress ossidativo',
          ],
        },
        contour: {
          statusTitle:    'Struttura da sostenere',
          objective:      'Stabilizzazione & riparazione',
          interpretation: 'I meccanismi biologici di riparazione iniziano a rallentare. La priorit\u00e0 \u00e8 stabilizzare la struttura esistente e sostenere attivamente i processi naturali di riparazione.',
          quote:          'L\u2019organismo perde progressivamente la sua capacit\u00e0 di riparazione. I meccanismi biologici devono essere sostenuti.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice di MyPureSkin',
          actions: [
            'Rallentare l\u2019accelerazione dell\u2019invecchiamento strutturale',
            'Sostenere la rigenerazione tissutale',
            'Ripristinare la qualit\u00e0 della pelle e la resilienza globale',
            'Preservare l\u2019equilibrio infiammatorio',
            'Combattere la cellulite e attivare il drenaggio',
          ],
        },
        lift: {
          statusTitle:    'Struttura ben conservata da mantenere',
          objective:      'Prevenzione & mantenimento',
          interpretation: 'La sua struttura biologica \u00e8 generalmente ben conservata. In questa fase, l\u2019obiettivo non \u00e8 correggere, ma rallentare i meccanismi di degradazione biologica legati all\u2019invecchiamento, prima che si instaurino.',
          quote:          'In questa fase, non si corregge ancora. Si preserva la struttura.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice di MyPureSkin',
          actions: [
            'Sostenere la densit\u00e0 cutanea',
            'Mantenere i meccanismi naturali di rigenerazione',
            'Preservare l\u2019equilibrio infiammatorio',
          ],
        },
      },

      femme: {
        c1: {
          statusTitle:    'Struttura ben conservata da mantenere',
          objective:      'Prevenzione & mantenimento',
          interpretation: 'La sua struttura biologica \u00e8 generalmente ben conservata. In questa fase, l\u2019obiettivo non \u00e8 correggere, ma rallentare i meccanismi di degradazione biologica legati all\u2019invecchiamento, prima che si instaurino.',
          quote:          'In questa fase, non si corregge ancora. Si preserva la struttura.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice di MyPureSkin',
          actions: [
            'Sostenere la densit\u00e0 cutanea',
            'Mantenere i meccanismi naturali di rigenerazione',
            'Preservare l\u2019equilibrio infiammatorio',
          ],
        },
        c2: {
          statusTitle:    'Struttura ben conservata da mantenere',
          objective:      'Prevenzione, mantenimento & supporto alla perdita di peso',
          interpretation: 'La sua struttura biologica \u00e8 generalmente ben conservata. In questa fase, non si tratta di correggere una degradazione strutturale, ma di preservare le fondamenta sostenendo al contempo una riduzione del tessuto adiposo. L\u2019obiettivo \u00e8 sostenere le funzioni metaboliche, la qualit\u00e0 dei tessuti e il tono, per favorire una perdita di peso pi\u00f9 armoniosa e duratura.',
          quote:          'In questa fase, non si corregge ancora. Si preserva la struttura \u2014 sostenendo al contempo l\u2019equilibrio metabolico.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice di MyPureSkin',
          actions: [
            'Preservare la densit\u00e0 e la qualit\u00e0 dei tessuti',
            'Mantenere i meccanismi naturali di rigenerazione',
            'Sostenere l\u2019equilibrio infiammatorio e metabolico',
            'Supportare la perdita di peso senza indebolire la struttura',
            'Favorire il drenaggio e l\u2019armonia della silhouette',
          ],
        },
        c3: {
          statusTitle:    'Struttura ben conservata da mantenere',
          objective:      'Prevenzione & mantenimento',
          interpretation: 'La sua struttura biologica \u00e8 generalmente ben conservata. In questa fase, l\u2019obiettivo non \u00e8 correggere, ma rallentare i meccanismi di degradazione biologica legati all\u2019invecchiamento, prima che si instaurino.',
          quote:          'In questa fase, non si corregge ancora. Si preserva la struttura.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice di MyPureSkin',
          actions: [
            'Sostenere la densit\u00e0 cutanea',
            'Mantenere i meccanismi naturali di rigenerazione',
            'Preservare l\u2019equilibrio infiammatorio',
          ],
        },
        c4: {
          statusTitle:    'Struttura ben conservata da mantenere',
          objective:      'Prevenzione, mantenimento & supporto alla perdita di peso',
          interpretation: 'La sua struttura biologica \u00e8 generalmente ben conservata. In questa fase, non si tratta di correggere una degradazione strutturale, ma di preservare le fondamenta sostenendo al contempo una riduzione del tessuto adiposo. L\u2019obiettivo \u00e8 sostenere le funzioni metaboliche, la qualit\u00e0 dei tessuti e il tono, per favorire una perdita di peso pi\u00f9 armoniosa e duratura.',
          quote:          'In questa fase, non si corregge ancora. Si preserva la struttura \u2014 sostenendo al contempo l\u2019equilibrio metabolico.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice di MyPureSkin',
          actions: [
            'Preservare la densit\u00e0 e la qualit\u00e0 dei tessuti',
            'Mantenere i meccanismi naturali di rigenerazione',
            'Sostenere l\u2019equilibrio infiammatorio e metabolico',
            'Supportare la perdita di peso senza indebolire la struttura',
            'Favorire il drenaggio e l\u2019armonia della silhouette',
          ],
        },
        c5: {
          statusTitle:    'Struttura ben conservata da mantenere',
          objective:      'Prevenzione, mantenimento & anticipazione dei cambiamenti ormonali',
          interpretation: 'La sua struttura biologica \u00e8 generalmente ben conservata. In questa fase, l\u2019obiettivo non \u00e8 correggere, ma rallentare i meccanismi di degradazione biologica legati all\u2019invecchiamento, anticipando i cambiamenti ormonali associati alla peri-menopausa o alla menopausa. Questa fase chiave influenza la qualit\u00e0 dei tessuti, l\u2019infiammazione e la capacit\u00e0 di rigenerazione, da qui l\u2019importanza di un supporto preventivo.',
          quote:          'In questa fase, non si corregge ancora. Si preserva la struttura.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice di MyPureSkin',
          actions: [
            'Sostenere la densit\u00e0 e la qualit\u00e0 dei tessuti',
            'Mantenere i meccanismi naturali di rigenerazione',
            'Preservare l\u2019equilibrio infiammatorio',
            'Anticipare gli impatti ormonali sulla struttura cutanea e tissutale',
            'Sostenere gli impatti ormonali della menopausa',
          ],
        },
        c6: {
          statusTitle:    'Struttura ben conservata da mantenere',
          objective:      'Prevenzione, mantenimento & anticipazione dei cambiamenti ormonali',
          interpretation: 'La sua struttura biologica \u00e8 generalmente ben conservata. In questa fase, l\u2019obiettivo non \u00e8 correggere, ma rallentare i meccanismi di degradazione biologica legati all\u2019invecchiamento, anticipando i cambiamenti ormonali associati alla peri-menopausa o alla menopausa. Questa fase chiave pu\u00f2 essere accompagnata da cambiamenti metabolici, una tendenza all\u2019aumento di peso e cambiamenti nella distribuzione dei grassi, influenzando la qualit\u00e0 dei tessuti, l\u2019infiammazione e la capacit\u00e0 di rigenerazione. Un supporto preventivo aiuta a preservare la struttura, l\u2019armonia della silhouette e il comfort corporeo.',
          quote:          'In questa fase, non si corregge ancora. Si preserva la struttura.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice di MyPureSkin',
          actions: [
            'Sostenere la densit\u00e0 e la qualit\u00e0 dei tessuti',
            'Mantenere i meccanismi naturali di rigenerazione',
            'Preservare l\u2019equilibrio infiammatorio',
            'Anticipare gli impatti ormonali sulla struttura cutanea e tissutale',
            'Sostenere l\u2019equilibrio metabolico per limitare l\u2019aumento di peso ormonale',
            'Favorire il drenaggio e limitare la formazione di cellulite',
          ],
        },
        c7: {
          statusTitle:    'Struttura da sostenere',
          objective:      'Supporto rinforzato alla rigenerazione',
          interpretation: 'La sua struttura biologica inizia a mostrare segni di indebolimento progressivo. In questa fase, l\u2019approccio deve essere globale: andare oltre l\u2019apparenza per sostenere la funzione, la capacit\u00e0 di recupero e la qualit\u00e0 dei tessuti, con un impatto diretto sulla qualit\u00e0 della vita.',
          quote:          'In questa fase, la sfida va oltre l\u2019apparenza: si tratta anche di sostenere la funzionalit\u00e0, il recupero e la qualit\u00e0 dei tessuti.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice di MyPureSkin',
          actions: [
            'Sostenere intensamente i meccanismi biologici di riparazione',
            'Migliorare la capacit\u00e0 di recupero e la resilienza globale',
            'Ridurre l\u2019infiammazione cronica e lo stress ossidativo',
          ],
        },
        c8: {
          statusTitle:    'Struttura indebolita',
          objective:      'Supporto rinforzato alla rigenerazione e alla struttura',
          interpretation: 'La sua struttura biologica mostra segni di indebolimento avanzato. In questa fase, l\u2019approccio deve essere globale e funzionale: andare oltre l\u2019apparenza per sostenere i meccanismi di riparazione, il recupero, la qualit\u00e0 dei tessuti e l\u2019equilibrio metabolico, con un impatto diretto sulla silhouette, la mobilit\u00e0 e la qualit\u00e0 della vita.',
          quote:          'In questa fase, la sfida va oltre l\u2019apparenza: si tratta anche di sostenere la funzionalit\u00e0, il recupero, la qualit\u00e0 dei tessuti e l\u2019equilibrio metabolico.',
          quoteAuthor:    'Tatiana Brandt, co-fondatrice di MyPureSkin',
          actions: [
            'Sostenere intensamente i meccanismi biologici di riparazione',
            'Migliorare la capacit\u00e0 di recupero e la resilienza globale',
            'Ridurre l\u2019infiammazione cronica e lo stress ossidativo',
            'Preservare l\u2019equilibrio infiammatorio',
            'Sostenere la qualit\u00e0 dei tessuti, combattere la cellulite e attivare il drenaggio',
            'Favorire un rimodellamento pi\u00f9 armonioso della silhouette',
          ],
        },
      },
    },
  },

};
